import { toast } from 'react-toastify';
import { TOAST_MESSAGES } from '../constants/global-constants';
import { UserDetails } from '../constants/telosair-interfaces';
import { buildInviteUrl, createInviteLink } from '../services/dashboard-service';

/**
 * Creates a one-time invitation link for a user and puts it on the clipboard.
 * Only works for users who haven't set a password yet; the server says so otherwise.
 * @param user - The invitee.
 */
export default async function copyInviteLink(user: UserDetails): Promise<void> {
  try {
    const { data } = await createInviteLink(user.id);
    const url = buildInviteUrl(data.token);
    try {
      await navigator.clipboard.writeText(url);
      toast.success(`Invite link for ${user.userName} copied. It works once and expires in 7 days.`);
    } catch {
      // Clipboard access can be refused (e.g. the tab lost focus while the
      // request was in flight); show the link so it can be copied by hand.
      // eslint-disable-next-line no-alert
      window.prompt('Copy this invite link:', url);
    }
  } catch (e: any) {
    toast.error(e?.response?.data?.message || TOAST_MESSAGES.error);
  }
}
